/**
 * @fileoverview Forced change-password page.
 * @description The /change-password route, reachable only by a signed-in user who must change
 * their password before doing anything else (see ForcePasswordChangeRoute). Rendered on
 * AuthLayout — like login and two-factor — rather than inside the dashboard shell, so no header,
 * sidebar, profile/settings menu, or back link is offered while the session is restricted. A
 * voluntary change from Settings uses ChangePasswordModal instead of this page.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { ChangePasswordCard } from '@/features/auth'
import AuthLayout from '@/shared/components/layouts/AuthLayout'

/**
 * @component
 */
function ChangePasswordPage() {
  return (
    <AuthLayout>
      <ChangePasswordCard />
    </AuthLayout>
  )
}

export default ChangePasswordPage
